import { IStockQuantityLocation } from 'interfaces';
import { BaseService } from './BaseService';
import { axiosPrivate } from 'services/axios';

class StockQuantityLocationService extends BaseService<IStockQuantityLocation> {
  constructor() {
    super('stock-quantity-locations');
  }

  getUnloadStockLocation = async (limit = 0, offset = 0, params: Record<string, unknown> = {}) => {
    const res = await axiosPrivate.get(`${this.modulePrefix}/unload_stocks/`, {
      params: { limit, offset, ...params }
    });
    return res.data;
  };
}
export const stockQuantityLocationService = new StockQuantityLocationService();
